require('./lbaLeafletMap.scss');

const $inject = [];

const lbaLeafletMap = function () {
  return {
    controller: 'lbaLeafletMapCtrl',
    controllerAs: 'vm',
    bindToController: true,
    template: require('./lbaLeafletMapTemplate.html'),
    scope: {
      locations: '=',
      mapCenter: '=',
      zoomLevel: '<',
      markerClick : '=',
      bounds : '=',
      markerOverride: '<',
      includesRadius: '<'
    }
  }
};

lbaLeafletMap.$inject = $inject;

export default lbaLeafletMap;



// WEBPACK FOOTER //
// ./src/components/lbaLeafletMap/lbaLeafletMapDir.js